import { connect } from 'react-redux';
import { formatCurrencyUSD } from '../../utils/utility.js';
import { updateDownPayment } from '../../actions/updateCalculator';
import PriceInput from '../../components/inputs/PriceInput';

const mapStateToProps = (state, props) => {
	return {
		formattedValue: formatCurrencyUSD(
			state.calculatorData.current.downPayment
		),
		value: state.calculatorData.current.downPayment,
		placeholder: 'Down Payment',
		passedProps: { ...props }
	};
};

const mapDispatchToProps = dispatch => {
	return {
		updateValue: newValue => {
			dispatch(updateDownPayment(newValue));
		}
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PriceInput);



// WEBPACK FOOTER //
// ./src/containers/inputs/DownPaymentInputController.jsx